import type { PointerEventHandler } from "react";

/** Applied to `<body>` while pointer-dragging (e.g. sliders) — hides `CcCursorDot`, shows grab cursor. */
export const CC_CURSOR_HIDE_BODY_ATTR = "data-cc-hide-cursor";

let dragDepth = 0;

export function isCcCursorHiddenByDrag(): boolean {
  if (typeof document === "undefined") return false;
  return document.body.hasAttribute(CC_CURSOR_HIDE_BODY_ATTR);
}

function syncBodyDragAttr() {
  if (typeof document === "undefined") return;
  if (dragDepth > 0) {
    document.body.setAttribute(CC_CURSOR_HIDE_BODY_ATTR, "");
    return;
  }
  document.body.removeAttribute(CC_CURSOR_HIDE_BODY_ATTR);
}

function releaseCcCursorDrag() {
  dragDepth = Math.max(0, dragDepth - 1);
  syncBodyDragAttr();
}

/** Call on pointer down when starting a drag interaction. */
export function beginCcCursorDrag(): void {
  dragDepth += 1;
  syncBodyDragAttr();
}

/** Call on pointer up / cancel when ending a drag interaction. */
export function endCcCursorDrag(): void {
  releaseCcCursorDrag();
}

/** Wire on slider roots (and similar) — pairs with window `pointerup` / `pointercancel`. */
export function onCcCursorDragPointerDown(): void {
  beginCcCursorDrag();

  const release = () => {
    window.removeEventListener("pointerup", release);
    window.removeEventListener("pointercancel", release);
    endCcCursorDrag();
  };

  window.addEventListener("pointerup", release);
  window.addEventListener("pointercancel", release);
}

export function mergeCcCursorDragPointerDown(
  userHandler?: PointerEventHandler,
): PointerEventHandler {
  return (event) => {
    onCcCursorDragPointerDown();
    userHandler?.(event);
  };
}
